// Which solutions each plan includes, by solution page path. Text comes from the locale (solutions menu, pricingPage)
// The cheapest plan of a billing period is Basic: it gets every solution except the ones listed here.
// Every pricier plan and Enterprise get all of them
const PricingPlansConfig = {
	advancedOnly: [
		'/solutions/delivery',
		'/solutions/multi-branch',
		'/solutions/customer-club',
		'/solutions/automatic-campaigns',
		'/solutions/tiered-discounts',
		'/solutions/smart-surveys',
		'/solutions/smart-inventory',
		'/solutions/stock-alerts',
		'/solutions/menu-engineering',
		'/solutions/loss-prevention',
		'/solutions/menu-costing',
		'/solutions/website',
		'/solutions/google-reviews',
		'/solutions/seo',
		'/solutions/instagram'
	]
}

export default PricingPlansConfig
